var a = ((a2) => (a2.MainOffice = "b419c55c-e197-4338-893f-4daa4050baf5", a2.GasDistributionNetwork = "f2dc1a95-3dbe-4517-8e9f-487e702607c2", a2.StructuralSubdivision = "86b7f0a6-4160-4829-bca0-e8465d953439", a2))(a || {});
export {
  a as OrganizationTypeId
};
//# sourceMappingURL=types.js.map
